import React from 'react';
import { Icon } from 'semantic-ui-react';

/**
 * Render the header content with a sort icon but without the actual <th> element.
 * Doubles as the column drag handle, so that the filter input and the resize
 * handle stay outside the draggable element and keep their native behaviour.
 */
export function HeaderContent({
  children,
  id,
  sortString,
  style,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & {
  id: string;
  sortString: string | null;
}) {
  if (id === 'select') {
    // select column doesn't need a sort icon, and is never draggable
    return <>{children}</>;
  }

  let sortIcon: React.ReactNode | null = null;
  if (sortString === 'asc') {
    sortIcon = <Icon name="arrow up" style={{ margin: 0 }} />;
  } else if (sortString === 'desc') {
    sortIcon = <Icon name="arrow down" style={{ margin: 0 }} />;
  }

  return (
    <div
      {...rest}
      style={{
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 5.5em',
        justifyContent: 'space-between',
        ...style,
      }}
      className="lp-table-header-content"
    >
      <span>{children}</span>
      {sortIcon}
    </div>
  );
}
